





















































import { computed, defineComponent, ref, watch, inject } from "@vue/composition-api";
import { MessageLinkSubject } from "@scrile/api-provider/dist/api/MessageLinksProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { CREDITS_CURRENCY_CODE } from "@scrile/tools/dist/lib/MoneyHelpers";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { handleRequestError } from "@/lib/handleRequestError";
import { $t } from "@/lib/i18nHelpers";
import { getCurrencySymbol } from "@/lib/moneyHelpers";
import config from "@/config";
import { ERRORS } from "@/const";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseInput from "@/components/BaseInput";
import BaseSendMessage from "@/components/BaseSendMessage";
import PaidActionError from "@/components/PaidActionError";

export default defineComponent({
  name: "TipController",
  components: { BaseSendMessage, BaseInput, BaseIcon, PaidActionError, BaseIconButton },
  props: {
    threadId: { type: String },
    transparent: { type: Boolean, default: false },
    linkSubject: { type: Object as () => MessageLinkSubject },
  },
  setup(props, { emit }) {
    const data = inject<{ user: UserPublicData | null }>("messageData", { user: null });
    const userId = computed(() => data.user?.id ?? "");
    const tipValue = ref("");
    const processing = ref(false);
    const currencySymbol = $t(getCurrencySymbol(CREDITS_CURRENCY_CODE));
    const allowSend = computed(() => {
      return tipValue.value.length !== 0 && +tipValue.value > 0;
    });
    const show = ref(false);
    const toggleShow = () => (show.value = !show.value);
    watch(show, () => {
      tipValue.value = "";
    });
    const showPaidError = ref(false);

    const tipValueInput = (v: string) => {
      const value = Number(v.replace(" ", "").replace(currencySymbol, "") ?? 0) || 0;
      if (isNaN(value) || value === 0) {
        tipValue.value = "";
      } else {
        tipValue.value = value.toString();
      }
    };

    const submit = async () => {
      if (!userId.value || !allowSend.value) return;
      try {
        processing.value = true;
        const tipAmount = tipValue.value;
        providers.TipProvider.setReceiveErrors(false);
        await providers.TipProvider.create({
          data: {
            recipientId: userId.value,
            amount: +tipAmount,
            threadId: props.threadId,
            linkSubject: props.linkSubject,
          },
        });
        emit("success");
        tipValue.value = "";
        show.value = false;
      } catch (e) {
        handleRequestError(
          e,
          e => e.details?.messageTemplate === ERRORS.NOT_ENOUGH_FUNDS_ERROR,
          () => (showPaidError.value = true)
        );
      } finally {
        processing.value = false;
        tipValue.value = "";
      }
    };
    const { authUser } = useAuthUser();

    const activateTip = computed(
      () =>
        checkRole(authUser.value?.role || "", config.userRegistrationRole) &&
        checkRole(data.user?.role || "", "creator")
    );

    const openerIcon = computed(() => (show.value ? "sci-close" : "sci-gift"));
    return {
      currencySymbol,
      tipValue,
      tipValueInput,
      allowSend,
      processing,
      submit,
      activateTip,
      openerIcon,
      show,
      toggleShow,
      showPaidError,
    };
  },
});
